export const ReportsRoutes = { path: 'report/*', lazy: () => import('../pages/reports') };
